export default function getDistance(kilometres: number) {
  // If less than 1km, show meters
  const meters = Math.round(kilometres * 1000);
  if (meters < 1) return "<1 m";
  if (meters < 1000) return `${meters} m`;
  else return `${kilometres.toFixed(1)} km`;
}
